import Marquee from "react-fast-marquee";

const WORDS = ["Writer", "Producer", "Storyteller", "Onyx & Ochre", "Film", "Television"];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative z-10 bg-surface-warm py-10 md:py-14 border-t border-b border-[#CFD3DE] overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl sm:text-5xl lg:text-6xl text-onyx px-8">
              {w}
            </span>
            <span className="text-ochre text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
